import { render } from "./loginPage.vue?vue&type=template&id=537341f4"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yuviony/vspl/ui/vetaconnect_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__